import * as React from "react";
import "./css/style.css"
import {HTMLAttributes} from "react";

export default class SearchBox  extends React.Component<SearchBoxProps,SearchBoxStatus>{

    public timeout:any;
    public static defaultProps:Partial<SearchBoxProps>={
        delay:200
    }

    constructor(){
        super();
        this.OnKeyUp=this.OnKeyUp.bind(this);
        this.state={
            focused:false,
        }
    }



    OnFocus(event:any){
        this.setState({focused:true});
        event.target.setSelectionRange(0, event.target.value.length);

    }

    render(): any{
        const {onBoxKeyUp,delay,...rest}=this.props;
       return <div className={'rednaoSearchContainer '+(this.state.focused?'focused':'')} {...rest} >
                   <input placeholder={this.props.placeholder} onInput={this.OnKeyUp} className="form-control rednaoSearchBox" onBlur={()=>{this.setState({focused:false})}} onFocus={this.OnFocus.bind(this)}/>
                   <span className="glyphicon glyphicon-search rednaoSearchIcon"></span>
               </div>;
    }

    OnKeyUp(e){
        let value=e.target.value.toString();
        if(this.timeout!=null) {
            clearTimeout(this.timeout);
            this.timeout=null;
        }
        this.timeout=setTimeout(()=>{
            this.timeout=null;
            this.props.onBoxKeyUp&&this.props.onBoxKeyUp(value);
        },this.props.delay);


    }

}

export interface SearchBoxStatus{
    focused:boolean;
}

export interface SearchBoxProps extends React.HTMLProps<HTMLDivElement>{
    onBoxKeyUp?: (text:string)=>void;
    delay?:number;
}


// WEBPACK FOOTER //
// C:/wamp/www/node_modules/rednao-search-box/index.tsx